import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import FeedBackGrid from '../components/FeedBackGrid';
import Pagination from '../components/Pagination';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchFeedBackListWidgets, clearFeedBackListWidgets } from '../actions/getFeedBackListWidget';
import { fetchFeedBackListData, clearFetchingFeedBackListData } from '../actions/fetchFeedBackListData';
import { setSorting, resetSorting, toggleSorting } from '../actions/sortingActions';
import FeedBackGridLoader from '../components/Loader';
import { parseFilters } from '../../Filters/utils/fetchData';
import { useWindowDimensions } from 'react-native';

const FeedbackList = props => {
  const {
    actions,
    feedback_widget_data,
    feedback_list_data,
    hotels,
    applied_filter_values,
    isFetchingData,
    isFetchingWidgets,
    sortReducer,
    filtersLoading
  } = props;


  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = feedback_widget_data?.contents?.page_size;
  const totalCount = Number(get(feedback_list_data?.contents?.data, 'count')) || 0;
  const totalPages = Math.ceil(totalCount / pageSize);

  const startIndex = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  const tableTitle = `Records ${startIndex}-${endIndex} of ${totalCount}`;

  const hotelCount = Object.keys(hotels || {}).length;
  const role = hotelCount > 1 ? 'muo' : 'property';

  useEffect(() => {
    actions.fetchFeedBackListWidgets();
  }, [actions]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const handleOnSortClick = key => {
    if (key === 'nps_score') {
      actions.toggleSorting('likelihood_to_recommend');
    } else {
      actions.toggleSorting(key);
    }
  };

  useEffect(() => {
    const { filters, benchmark } = parseFilters(applied_filter_values);

    if (!filters || Object.keys(filters).length === 0) return;

    actions.fetchFeedBackListData(currentPage, filters);
  }, [sortReducer, currentPage, applied_filter_values]);

  if (isFetchingData || isFetchingWidgets || filtersLoading) {
    return (
      <View style={{ margin: isMobile ? 0 : 30 }}>
        <FeedBackGridLoader />
      </View>
    );
  }

  return (
    <View style={{ margin: isMobile ? 0 : 30 }}>
      <FeedBackGrid
        feedbackdata={feedback_list_data?.contents?.data}
        feedbackwidget={feedback_widget_data?.contents}
        sortingPayload={sortReducer}
        tableTitle={tableTitle}
        currentPage={currentPage}
        role={role}
        handleOnSortClick={handleOnSortClick}
      />

      {totalPages !== 0 && (
        <View style={{ marginVertical: 20 }}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </View>
      )}
    </View>
  );
};

const mapStateToProps = state => ({
  feedback_widget_data: state.feedBackListReducer.feedback_widget_data,
  feedback_list_data: state.feedBackListReducer.feedback_list_data,
  isFetchingData: state.feedBackListReducer.isFetchingData,
  isFetchingWidgets: state.feedBackListReducer.isFetchingWidgets,
  hotels: get(state, 'entities.hotels', {}),
  applied_filter_values: get(state, 'filterReducer.applied_filter_values'),
  sortReducer: state.sortReducer,
  filtersLoading:get(state, 'filterReducer.filtersLoading'),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchFeedBackListWidgets,
      fetchFeedBackListData,
      clearFeedBackListWidgets,
      clearFetchingFeedBackListData,
      setSorting,
      resetSorting,
      toggleSorting
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackList);
